import { BASE_URL } from './../utils/helpers'

export const CHARACTER_REQUEST = 'CHARACTER_REQUEST';
export const CHARACTER_SUCCESS = 'CHARACTER_SUCCESS';
export const CHARACTER_FAILED = 'CHARACTER_FAILED';

export const getCharacter = id => {
  return async dispatch => {
    try {
      dispatch({ type: CHARACTER_REQUEST });
      const response = await fetch(`${BASE_URL}character/${id}`);
      if (response) {
        const character = await response.json();
        const lastEpisode = character.episode.slice(0,5);

        const getEpisodeIndex = lastEpisode.map( item => {
          const getItemIndex = item.replace(/[^0-9]/g, '')
          return parseInt(getItemIndex, 10);
        });

        const getEpisodes = await fetch(`${BASE_URL}episode/${ getEpisodeIndex }`);

        if (getEpisodes) {
          const episodes = await getEpisodes.json();
          const getEpisode = Array.isArray(episodes) ? episodes : [episodes];

          dispatch({ 
            type: CHARACTER_SUCCESS, 
            payload: {
              character,
              episodes: getEpisode,
            },
          });
        }
        
      }
    } catch (error) {
      dispatch({ type: CHARACTER_FAILED, payload: error });
    }
  }
};